<template>
	<section>
		<router-view></router-view>
	</section>
</template>

<script>
	export default {}
</script>



// WEBPACK FOOTER //
// Register.vue?1bc2354a